RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Error = Marionette.ItemView.extend({
        className: 'application-error',
        template: '#shellErrorTemplate'
    });

});
